import { memo } from 'react';

import Text from '@zenbusiness/zui/Text';

import { AlertStyled } from './MoneyAlert.styles';

function MoneyAlert() {
  return (
    <AlertStyled>
      <Text
        color="primary"
        size="md"
      >
        <Text
          color="primary"
          size="md"
          weight="medium"
        >
          Not fast enough?
        </Text>{' '}
        Choose a different option to send your money quicker. ⚡️
      </Text>
    </AlertStyled>
  );
}

export default memo(MoneyAlert);
